import { Common } from './Common';
import { ElectionMember } from './ElectionMember';

export class Election extends Common {
    candidate_rule: any;
    election_rule: any;
    member_rule: any;
    election_start_date: Date;
    election_end_date: Date;
    candidate_final_date: Date;
    member_final_date: Date;
    result_date: Date;
    result: string;
    per_member_rate: number;
    amount_received: number;
    heading: string;
    theme: string;
    committee_id: string;

    status: string;
    type: string;
    member_list: ElectionMember[];
    candidate_list: ElectionMember[];
}